
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index4iEvdLIe7_N_WfWuhZjpfiNgtrKigc10ftdSWNuEnEgMeta } from "/opt/build/repo/pages/users/accept-invite/[uuid]/index.vue?macro=true";
import { default as newDrGeGpcfQM88GA7b1lgaI5w8v_3DvhnQQ8573D0onf8Meta } from "/opt/build/repo/pages/companies/new.vue?macro=true";
import { default as addiHaofy1xMW5rqbX14i9VprAwcJ85pFc_mJX7Irnk9XwMeta } from "/opt/build/repo/pages/inventory/add.vue?macro=true";
import { default as transfer45ycDZ5ZoMVX5Iakd2tV2TQkoIForhC4_yYrLcXr5WAMeta } from "/opt/build/repo/pages/inventory/transfer.vue?macro=true";
import { default as newCn5JSGaSW5Odvg8ELyE8by_18bLinxlbGNp5FnIC4Y4Meta } from "/opt/build/repo/pages/orders/new.vue?macro=true";
import { default as newjprGiRrRDrv4NOAm0bLS9GBcvkWEGuX_NolO3FeAX3kMeta } from "/opt/build/repo/pages/projects/new.vue?macro=true";
import { default as bom_45itemsiTOOKPan8CNHmasUrrcymjt6xMkCIV6UK0Ylma4DSP4Meta } from "/opt/build/repo/pages/purchase-orders/new/bom-items.vue?macro=true";
import { default as new0qSXK1sVifMz9QtUEj0DKeuXimv0MavYJgtimw4uCmYMeta } from "/opt/build/repo/pages/purchase-orders/new.vue?macro=true";
import { default as new6nHWqb7LCv1Qrq3Qc2QOvIi0eQr1a6OPovY3LHqXSiQMeta } from "/opt/build/repo/pages/users/new.vue?macro=true";
import { default as edit4btEqLweB2QXRaj9U1fiz1FH9nLtogs8S_8SnIhq_AkMeta } from "/opt/build/repo/pages/users/[id]/edit.vue?macro=true";
import { default as _91id_93DhQeBoA4kM2PPi3xms__wQbSiAYh4f7fFiwIVmhB9JYMeta } from "/opt/build/repo/pages/companies/[id].vue?macro=true";
import { default as editbUZbYZkVyVpTqpgARPF32vgLz_nlCsm7YyX1lg7_ReAMeta } from "/opt/build/repo/pages/orders/[id]/invoices/[invoice]/edit.vue?macro=true";
import { default as _91invoice_93e55pWBSDsYHhooy1bSEpc_7kIt9UInf_OD2H9vztcpAMeta } from "/opt/build/repo/pages/orders/[id]/invoices/[invoice].vue?macro=true";
import { default as _91quote_930CvDzyGejnpmE712DH2g4wzdvxkaTuWkGXiJ5BzkSMAMeta } from "/opt/build/repo/pages/orders/[id]/quotes/[quote].vue?macro=true";
import { default as bom_45itemsk12HKFRCUKdQkYaPfC2GDBkx9XsO_XiFGv0zubnO4vAMeta } from "/opt/build/repo/pages/orders/[id]/change-order/bom-items.vue?macro=true";
import { default as change_45orderWcrJ28nSWAeoEy9Ba3xbMbQ0yFu_OS0JXleX0hAYf9sMeta } from "/opt/build/repo/pages/orders/[id]/change-order.vue?macro=true";
import { default as bom_45itemsr2VASGPugj6lrUReim2Od0XqTlCbIOq6Y7q2QBbvYIMMeta } from "/opt/build/repo/pages/orders/[id]/complete-draft/bom-items.vue?macro=true";
import { default as complete_45draftLYD_2C85VuyTkL_XTXZcjXjSPKpvg3_BKAVizj44DssMeta } from "/opt/build/repo/pages/orders/[id]/complete-draft.vue?macro=true";
import { default as bom_45itemsy7Yrb2EAjeMeKSFvUMKesxcalvWVKg7PFMQRhUd7FlAMeta } from "/opt/build/repo/pages/orders/[id]/final-adjustments/bom-items.vue?macro=true";
import { default as final_45adjustmentsXwrWwElqncO9kfnAJQ_KWOWpflSrl61RCyqcN3mGPPEMeta } from "/opt/build/repo/pages/orders/[id]/final-adjustments.vue?macro=true";
import { default as receiveRdOoF_2bF5xTx9Ek3QfW8_WwbBzI8_XoO_CeVKN7_D0Meta } from "/opt/build/repo/pages/orders/[id]/receive.vue?macro=true";
import { default as _91id_93dWQGHkP2ZiXwthg3lYEbXH_RM9VptslrhcqPfONkXLwMeta } from "/opt/build/repo/pages/orders/[id].vue?macro=true";
import { default as indexprIyOdRTqfxRzolNK253knIhoKkRG2WoL_zEVhsfj0YMeta } from "/opt/build/repo/pages/projects/[id]/boms/[bomId]/index.vue?macro=true";
import { default as _91bomId_93VuOpXo_TnMpXTnST3V4sErEOvuQaAc_LsWpUA7pRCcMMeta } from "/opt/build/repo/pages/projects/[id]/boms/[bomId].vue?macro=true";
import { default as indexBX58bQISY1VYo_Wz8CU5cAz0R5YuROecMIV6BeXO8K4Meta } from "/opt/build/repo/pages/projects/[id]/index.vue?macro=true";
import { default as _91id_93Hz9G7CVSytVYMe3Ox5AziiJMxgFROVbocG1I3Lb9q5MMeta } from "/opt/build/repo/pages/projects/[id].vue?macro=true";
import { default as _91uuid_93RJgQJlQcXQhwzmelrVGtkEo1OdE871bqpWWMULQeoNAMeta } from "/opt/build/repo/pages/verify-email/[uuid].vue?macro=true";
import { default as accountingf_OXI0_pNwENm_qDFv4BWI64aTXFhkdmjkEwn28zUcwMeta } from "/opt/build/repo/pages/accounting.vue?macro=true";
import { default as accounting_45exporti_eQjERxm4NAAeSrtJZIXgyD_iKtbRc8nOaWFXxD5sEMeta } from "/opt/build/repo/pages/accounting-export.vue?macro=true";
import { default as indexB_JFzTrHKOxKCfg98NsHuB9u88BRvwFHHo3pJyQgpCEMeta } from "/opt/build/repo/pages/admin/index.vue?macro=true";
import { default as adminoDxSfL1zfbtXOZhTEjupMIsD_tLPMDhEkobqeqFztjkMeta } from "/opt/build/repo/pages/admin.vue?macro=true";
import { default as indexA71hP_0b4wpNVzRpomu9YHXQV4BFEHgrlJgX7VYS5IsMeta } from "/opt/build/repo/pages/boms/index.vue?macro=true";
import { default as componentseh7D6mnBjAg7IfCAGQxCfAmMQv2_LEwhjTfpW5a_6jwMeta } from "/opt/build/repo/pages/components.vue?macro=true";
import { default as dashboarddIGQPcp2ZQEz5u2XKJHyyygOFdfmIecOhuIjtCy_6i0Meta } from "/opt/build/repo/pages/dashboard.vue?macro=true";
import { default as index_W_cGPvNZ4K2mhxuFSxIRJM87Ye5vsIuPoUUsDX2r70Meta } from "/opt/build/repo/pages/error-test/index.vue?macro=true";
import { default as editGyF4glqLoO1oRVFhuraXz_uMijB0zpopo71gf8bY7ccMeta } from "/opt/build/repo/pages/expenses/[id]/edit.vue?macro=true";
import { default as _91id_93LL7vsE0nSFJredRTWbC17m91d84hBmm7nNBQIbr0TA8Meta } from "/opt/build/repo/pages/expenses/[id].vue?macro=true";
import { default as expenseszSYrxJ4pkAgmqya1zPeOh5mSY6YFECca_M_bshqH6SIMeta } from "/opt/build/repo/pages/expenses.vue?macro=true";
import { default as forgot_45passwordOIFCeCN4AMh8hgrToHpDpWjsGVd3MBWi_zvta3PbADwMeta } from "/opt/build/repo/pages/forgot-password.vue?macro=true";
import { default as index52Ckz9CwUDhxG6WXgchvB5XbB8t2IYRStEKJvf7qCPoMeta } from "/opt/build/repo/pages/inventory/index.vue?macro=true";
import { default as index0Di72goBjyLuq31l5hhV78_uqtDkILlexkn05WIHbGAMeta } from "/opt/build/repo/pages/invoices/index.vue?macro=true";
import { default as invoicesksZypTfdfNkd37B_ULP3MP9EobbXZ_Air6nIR1UYV2MMeta } from "/opt/build/repo/pages/invoices.vue?macro=true";
import { default as logindGU_Y4tTcWsCg9HnKfbgxniTJNnqn8Xqf4N3mbSf_9QMeta } from "/opt/build/repo/pages/login.vue?macro=true";
import { default as indexOlWd9vFHguHOsQSBcDz6x2XeFrcv2t5_c0Q9Cv_IO0oMeta } from "/opt/build/repo/pages/orders/index.vue?macro=true";
import { default as profileYXN2cSixlL75SwObUUSDSPm9Xr5hPfQHYdM_txMKyrEMeta } from "/opt/build/repo/pages/profile.vue?macro=true";
import { default as indexJxu2jFkvSCWJf6gZ2nAdBaEA0U3aznS_LcN5i2h40XgMeta } from "/opt/build/repo/pages/projects/index.vue?macro=true";
import { default as quickbooks_45disconnectzbJFijVz2RRt1ZvMTNvxn26rouG5EIfNMgkzKPPqkDcMeta } from "/opt/build/repo/pages/quickbooks-disconnect.vue?macro=true";
import { default as indexnAKVgOczf25AS5BM5MNTvnnSDIoJLkFNj6AG55Q_I94Meta } from "/opt/build/repo/pages/requisitions/[id]/index.vue?macro=true";
import { default as requisitionsO_Ch7ICMFhaShjRCDBpEqzh8VR8_lakmBQ98H415idQMeta } from "/opt/build/repo/pages/requisitions.vue?macro=true";
import { default as sign_45upsbyFTKzb27ZDAAG4Ck628G_pZQrSR_Bg9SgR2KtFDGcMeta } from "/opt/build/repo/pages/sign-up.vue?macro=true";
import { default as sign_45up_45mobilekSphfmtsSEW21I8eowATaEaxbMvxmQC9sn181l7N25sMeta } from "/opt/build/repo/pages/sign-up-mobile.vue?macro=true";
import { default as signingH9sWnidwxK5Gb6uhbantoVD7Vv2UyWcTFgAho_B1seYMeta } from "/opt/build/repo/pages/signing.vue?macro=true";
import { default as new5tuZc0YebIKdTKEs_LUdmG_UqIVEYHx49D0i6yG6bf0Meta } from "/opt/build/repo/pages/suppliers/new.vue?macro=true";
import { default as editOxXru9nr3qSUpW7YNsqSdT0Ab_pQtEMFQtlRkacIVcwMeta } from "/opt/build/repo/pages/suppliers/[id]/edit.vue?macro=true";
import { default as suppliers6P25SzaXCJvxgtJhD7nKcsWhzypD51y2KJkd3W_qc2oMeta } from "/opt/build/repo/pages/suppliers.vue?macro=true";
import { default as index1mG8JMQgCyyObX5use_xFbRcEJCfqtvHcFdfbQ88imoMeta } from "/opt/build/repo/pages/users/index.vue?macro=true";
import { default as indexaAs6F0uOO1PbNxqH8DD_e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as importTubWTD76X2mlHQLUMnnlLcb5HaTjYyQ5na1vcYD35kcMeta } from "/opt/build/repo/pages/companies/[id]/suppliers/import.vue?macro=true";
import { default as addp2DhqDq3aJpc_eEZJikoFMFiw_qP3h_R7TizT2TD7iMMeta } from "/opt/build/repo/pages/companies/[id]/suppliers/index/add.vue?macro=true";
import { default as edit3TpG5mfsB40Z7F1_KWIXf_QrQXqTIg99GIBiQTD6lpUMeta } from "/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/edit.vue?macro=true";
import { default as _91companyVendorId_93_ukRrHpXs3GSefh_UXkwW2lmQ9YZNbhkkcOy_HPgtw0Meta } from "/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId].vue?macro=true";
import { default as suppliersCg_qTwztRQ3MMn8dTzFowm2HIsm6elSqDJApT5fKbKgMeta } from "/opt/build/repo/pages/companies/[id]/suppliers.vue?macro=true";
import { default as newgMUkRG1HRAaZ8RoZepmT7WnRoxwZMGmYvIyZommmfzcMeta } from "/opt/build/repo/pages/invoices/new.vue?macro=true";
import { default as newqJgyIzdTOzOXlmlIQXf8qv8eMv5XFVsXJF51awegkScMeta } from "/opt/build/repo/pages/requisitions/new.vue?macro=true";
import { default as editMo0HXlBs_0bnutKrnBJVabj54kD9rNFSDDlC4jU5JhQMeta } from "/opt/build/repo/pages/requisitions/[id]/edit.vue?macro=true";
export default [
  {
    name: "users-accept-invite-uuid",
    path: "/users/accept-invite/:uuid()",
    meta: index4iEvdLIe7_N_WfWuhZjpfiNgtrKigc10ftdSWNuEnEgMeta || {},
    component: () => import("/opt/build/repo/pages/users/accept-invite/[uuid]/index.vue")
  },
  {
    name: "companies-new",
    path: "/companies/new",
    meta: { ...(newDrGeGpcfQM88GA7b1lgaI5w8v_3DvhnQQ8573D0onf8Meta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/build/repo/pages/companies/new.vue")
  },
  {
    name: "inventory-add",
    path: "/inventory/add",
    meta: addiHaofy1xMW5rqbX14i9VprAwcJ85pFc_mJX7Irnk9XwMeta || {},
    component: () => import("/opt/build/repo/pages/inventory/add.vue")
  },
  {
    name: "inventory-transfer",
    path: "/inventory/transfer",
    meta: transfer45ycDZ5ZoMVX5Iakd2tV2TQkoIForhC4_yYrLcXr5WAMeta || {},
    component: () => import("/opt/build/repo/pages/inventory/transfer.vue")
  },
  {
    name: newCn5JSGaSW5Odvg8ELyE8by_18bLinxlbGNp5FnIC4Y4Meta?.name,
    path: "/orders/new",
    meta: { ...(newCn5JSGaSW5Odvg8ELyE8by_18bLinxlbGNp5FnIC4Y4Meta || {}), ...{"middleware":"can-get-quotes"} },
    component: () => import("/opt/build/repo/pages/orders/new.vue"),
    children: [
  {
    name: "orders-new-delivery",
    path: "delivery",
    component: () => import("/opt/build/repo/pages/orders/new/delivery.vue")
  },
  {
    name: "orders-new-invite-suppliers",
    path: "invite-suppliers",
    component: () => import("/opt/build/repo/pages/orders/new/invite-suppliers.vue")
  },
  {
    name: "orders-new-review",
    path: "review",
    component: () => import("/opt/build/repo/pages/orders/new/review.vue")
  },
  {
    name: "orders-new",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/new/index.vue")
  }
]
  },
  {
    name: "projects-new",
    path: "/projects/new",
    meta: newjprGiRrRDrv4NOAm0bLS9GBcvkWEGuX_NolO3FeAX3kMeta || {},
    component: () => import("/opt/build/repo/pages/projects/new.vue")
  },
  {
    name: new0qSXK1sVifMz9QtUEj0DKeuXimv0MavYJgtimw4uCmYMeta?.name,
    path: "/purchase-orders/new",
    meta: { ...(new0qSXK1sVifMz9QtUEj0DKeuXimv0MavYJgtimw4uCmYMeta || {}), ...{"middleware":"can-create-po"} },
    component: () => import("/opt/build/repo/pages/purchase-orders/new.vue"),
    children: [
  {
    name: "purchase-orders-new-bom-items",
    path: "bom-items",
    meta: bom_45itemsiTOOKPan8CNHmasUrrcymjt6xMkCIV6UK0Ylma4DSP4Meta || {},
    component: () => import("/opt/build/repo/pages/purchase-orders/new/bom-items.vue")
  },
  {
    name: "purchase-orders-new",
    path: "",
    component: () => import("/opt/build/repo/pages/purchase-orders/new/index.vue")
  }
]
  },
  {
    name: "users-new",
    path: "/users/new",
    meta: { ...(new6nHWqb7LCv1Qrq3Qc2QOvIi0eQr1a6OPovY3LHqXSiQMeta || {}), ...{"middleware":"can-manage-users"} },
    component: () => import("/opt/build/repo/pages/users/new.vue")
  },
  {
    name: "users-id-edit",
    path: "/users/:id()/edit",
    meta: { ...(edit4btEqLweB2QXRaj9U1fiz1FH9nLtogs8S_8SnIhq_AkMeta || {}), ...{"middleware":"can-manage-users"} },
    component: () => import("/opt/build/repo/pages/users/[id]/edit.vue")
  },
  {
    name: "boms-id",
    path: "/boms/:id()",
    component: () => import("/opt/build/repo/pages/boms/[id].vue")
  },
  {
    name: _91id_93DhQeBoA4kM2PPi3xms__wQbSiAYh4f7fFiwIVmhB9JYMeta?.name,
    path: "/companies/:id()",
    meta: { ...(_91id_93DhQeBoA4kM2PPi3xms__wQbSiAYh4f7fFiwIVmhB9JYMeta || {}), ...{"middleware":"can-manage-company"} },
    component: () => import("/opt/build/repo/pages/companies/[id].vue"),
    children: [
  {
    name: "companies-id-accounting-setup",
    path: "accounting/setup",
    meta: {"middleware":"staff"},
    component: () => import("/opt/build/repo/pages/companies/[id]/accounting/setup.vue")
  },
  {
    name: "companies-id-accounting",
    path: "accounting",
    component: () => import("/opt/build/repo/pages/companies/[id]/accounting/index.vue")
  },
  {
    name: "companies-id-cost-codes",
    path: "cost-codes",
    component: () => import("/opt/build/repo/pages/companies/[id]/cost-codes.vue")
  },
  {
    name: "companies-id-purchase-order",
    path: "purchase-order",
    component: () => import("/opt/build/repo/pages/companies/[id]/purchase-order.vue")
  },
  {
    name: "companies-id-report-config",
    path: "report-config",
    component: () => import("/opt/build/repo/pages/companies/[id]/report-config.vue")
  },
  {
    name: "companies-id-restricted",
    path: "restricted",
    meta: {"middleware":"staff"},
    component: () => import("/opt/build/repo/pages/companies/[id]/restricted.vue")
  },
  {
    name: "companies-id-roles",
    path: "roles",
    component: () => import("/opt/build/repo/pages/companies/[id]/roles.vue")
  },
  {
    name: "companies-id",
    path: "",
    component: () => import("/opt/build/repo/pages/companies/[id]/index.vue")
  }
]
  },
  {
    name: _91id_93dWQGHkP2ZiXwthg3lYEbXH_RM9VptslrhcqPfONkXLwMeta?.name,
    path: "/orders/:id()",
    meta: _91id_93dWQGHkP2ZiXwthg3lYEbXH_RM9VptslrhcqPfONkXLwMeta || {},
    component: () => import("/opt/build/repo/pages/orders/[id].vue"),
    children: [
  {
    name: _91invoice_93e55pWBSDsYHhooy1bSEpc_7kIt9UInf_OD2H9vztcpAMeta?.name,
    path: "invoices/:invoice()",
    component: () => import("/opt/build/repo/pages/orders/[id]/invoices/[invoice].vue"),
    children: [
  {
    name: editbUZbYZkVyVpTqpgARPF32vgLz_nlCsm7YyX1lg7_ReAMeta?.name,
    path: "edit",
    component: () => import("/opt/build/repo/pages/orders/[id]/invoices/[invoice]/edit.vue"),
    children: [
  {
    name: "orders-id-invoices-invoice-edit",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/invoices/[invoice]/edit/index.vue")
  }
]
  },
  {
    name: "orders-id-invoices-invoice",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/invoices/[invoice]/index.vue")
  }
]
  },
  {
    name: _91quote_930CvDzyGejnpmE712DH2g4wzdvxkaTuWkGXiJ5BzkSMAMeta?.name,
    path: "quotes/:quote()",
    component: () => import("/opt/build/repo/pages/orders/[id]/quotes/[quote].vue"),
    children: [
  {
    name: "orders-id-quotes-quote-match-items",
    path: "match-items",
    component: () => import("/opt/build/repo/pages/orders/[id]/quotes/[quote]/match-items.vue")
  },
  {
    name: "orders-id-quotes-quote",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/quotes/[quote]/index.vue")
  }
]
  },
  {
    name: "orders-id-bom-pricing",
    path: "bom-pricing",
    component: () => import("/opt/build/repo/pages/orders/[id]/bom-pricing.vue")
  },
  {
    name: change_45orderWcrJ28nSWAeoEy9Ba3xbMbQ0yFu_OS0JXleX0hAYf9sMeta?.name,
    path: "change-order",
    component: () => import("/opt/build/repo/pages/orders/[id]/change-order.vue"),
    children: [
  {
    name: "orders-id-change-order-bom-items",
    path: "bom-items",
    meta: bom_45itemsk12HKFRCUKdQkYaPfC2GDBkx9XsO_XiFGv0zubnO4vAMeta || {},
    component: () => import("/opt/build/repo/pages/orders/[id]/change-order/bom-items.vue")
  },
  {
    name: "orders-id-change-order",
    path: "",
    meta: {"middleware":"can-create-change-order"},
    component: () => import("/opt/build/repo/pages/orders/[id]/change-order/index.vue")
  }
]
  },
  {
    name: complete_45draftLYD_2C85VuyTkL_XTXZcjXjSPKpvg3_BKAVizj44DssMeta?.name,
    path: "complete-draft",
    component: () => import("/opt/build/repo/pages/orders/[id]/complete-draft.vue"),
    children: [
  {
    name: "orders-id-complete-draft-bom-items",
    path: "bom-items",
    meta: bom_45itemsr2VASGPugj6lrUReim2Od0XqTlCbIOq6Y7q2QBbvYIMMeta || {},
    component: () => import("/opt/build/repo/pages/orders/[id]/complete-draft/bom-items.vue")
  },
  {
    name: "orders-id-complete-draft",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/complete-draft/index.vue")
  }
]
  },
  {
    name: "orders-id-edit",
    path: "edit",
    component: () => import("/opt/build/repo/pages/orders/[id]/edit.vue")
  },
  {
    name: final_45adjustmentsXwrWwElqncO9kfnAJQ_KWOWpflSrl61RCyqcN3mGPPEMeta?.name,
    path: "final-adjustments",
    component: () => import("/opt/build/repo/pages/orders/[id]/final-adjustments.vue"),
    children: [
  {
    name: "orders-id-final-adjustments-bom-items",
    path: "bom-items",
    meta: bom_45itemsy7Yrb2EAjeMeKSFvUMKesxcalvWVKg7PFMQRhUd7FlAMeta || {},
    component: () => import("/opt/build/repo/pages/orders/[id]/final-adjustments/bom-items.vue")
  },
  {
    name: "orders-id-final-adjustments",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/final-adjustments/index.vue")
  }
]
  },
  {
    name: "orders-id-in-store",
    path: "in-store",
    component: () => import("/opt/build/repo/pages/orders/[id]/in-store.vue")
  },
  {
    name: "orders-id-invite-suppliers",
    path: "invite-suppliers",
    component: () => import("/opt/build/repo/pages/orders/[id]/invite-suppliers.vue")
  },
  {
    name: receiveRdOoF_2bF5xTx9Ek3QfW8_WwbBzI8_XoO_CeVKN7_D0Meta?.name,
    path: "receive",
    component: () => import("/opt/build/repo/pages/orders/[id]/receive.vue"),
    children: [
  {
    name: "orders-id-receive-submit",
    path: "submit",
    component: () => import("/opt/build/repo/pages/orders/[id]/receive/submit.vue")
  },
  {
    name: "orders-id-receive",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/receive/index.vue")
  }
]
  },
  {
    name: "orders-id-release",
    path: "release",
    component: () => import("/opt/build/repo/pages/orders/[id]/release.vue")
  },
  {
    name: "orders-id",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/index.vue")
  }
]
  },
  {
    name: _91id_93Hz9G7CVSytVYMe3Ox5AziiJMxgFROVbocG1I3Lb9q5MMeta?.name,
    path: "/projects/:id()",
    component: () => import("/opt/build/repo/pages/projects/[id].vue"),
    children: [
  {
    name: _91bomId_93VuOpXo_TnMpXTnST3V4sErEOvuQaAc_LsWpUA7pRCcMMeta?.name,
    path: "boms/:bomId()",
    meta: _91bomId_93VuOpXo_TnMpXTnST3V4sErEOvuQaAc_LsWpUA7pRCcMMeta || {},
    component: () => import("/opt/build/repo/pages/projects/[id]/boms/[bomId].vue"),
    children: [
  {
    name: "projects-id-boms-bomId-scan",
    path: "scan",
    component: () => import("/opt/build/repo/pages/projects/[id]/boms/[bomId]/scan.vue")
  },
  {
    name: indexprIyOdRTqfxRzolNK253knIhoKkRG2WoL_zEVhsfj0YMeta?.name,
    path: "",
    component: () => import("/opt/build/repo/pages/projects/[id]/boms/[bomId]/index.vue"),
    children: [
  {
    name: "projects-id-boms-bomId-index-orders",
    path: "orders",
    component: () => import("/opt/build/repo/pages/projects/[id]/boms/[bomId]/index/orders.vue")
  },
  {
    name: "projects-id-boms-bomId-index",
    path: "",
    component: () => import("/opt/build/repo/pages/projects/[id]/boms/[bomId]/index/index.vue")
  }
]
  }
]
  },
  {
    name: "projects-id",
    path: "",
    meta: indexBX58bQISY1VYo_Wz8CU5cAz0R5YuROecMIV6BeXO8K4Meta || {},
    component: () => import("/opt/build/repo/pages/projects/[id]/index.vue")
  }
]
  },
  {
    name: "verify-email-uuid",
    path: "/verify-email/:uuid()",
    meta: { ...(_91uuid_93RJgQJlQcXQhwzmelrVGtkEo1OdE871bqpWWMULQeoNAMeta || {}), ...{"middleware":"signup-enabled"} },
    component: () => import("/opt/build/repo/pages/verify-email/[uuid].vue")
  },
  {
    name: accountingf_OXI0_pNwENm_qDFv4BWI64aTXFhkdmjkEwn28zUcwMeta?.name,
    path: "/accounting",
    meta: accountingf_OXI0_pNwENm_qDFv4BWI64aTXFhkdmjkEwn28zUcwMeta || {},
    component: () => import("/opt/build/repo/pages/accounting.vue"),
    children: [
  {
    name: "accounting-pending-sync",
    path: "pending-sync",
    component: () => import("/opt/build/repo/pages/accounting/pending-sync.vue")
  },
  {
    name: "accounting",
    path: "",
    component: () => import("/opt/build/repo/pages/accounting/index.vue")
  }
]
  },
  {
    name: accounting_45exporti_eQjERxm4NAAeSrtJZIXgyD_iKtbRc8nOaWFXxD5sEMeta?.name,
    path: "/accounting-export",
    meta: accounting_45exporti_eQjERxm4NAAeSrtJZIXgyD_iKtbRc8nOaWFXxD5sEMeta || {},
    component: () => import("/opt/build/repo/pages/accounting-export.vue"),
    children: [
  {
    name: "accounting-export-order",
    path: ":order()",
    component: () => import("/opt/build/repo/pages/accounting-export/[order].vue")
  },
  {
    name: "accounting-export",
    path: "",
    component: () => import("/opt/build/repo/pages/accounting-export/index.vue")
  }
]
  },
  {
    name: adminoDxSfL1zfbtXOZhTEjupMIsD_tLPMDhEkobqeqFztjkMeta?.name,
    path: "/admin",
    meta: { ...(adminoDxSfL1zfbtXOZhTEjupMIsD_tLPMDhEkobqeqFztjkMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/build/repo/pages/admin.vue"),
    children: [
  {
    name: "admin-dashboard",
    path: "dashboard",
    component: () => import("/opt/build/repo/pages/admin/dashboard/index.vue")
  },
  {
    name: "admin-emails",
    path: "emails",
    component: () => import("/opt/build/repo/pages/admin/emails/index.vue")
  },
  {
    name: "admin",
    path: "",
    meta: indexB_JFzTrHKOxKCfg98NsHuB9u88BRvwFHHo3pJyQgpCEMeta || {},
    component: () => import("/opt/build/repo/pages/admin/index.vue")
  }
]
  },
  {
    name: "boms",
    path: "/boms",
    meta: indexA71hP_0b4wpNVzRpomu9YHXQV4BFEHgrlJgX7VYS5IsMeta || {},
    component: () => import("/opt/build/repo/pages/boms/index.vue")
  },
  {
    name: "components",
    path: "/components",
    meta: { ...(componentseh7D6mnBjAg7IfCAGQxCfAmMQv2_LEwhjTfpW5a_6jwMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/build/repo/pages/components.vue")
  },
  {
    name: dashboarddIGQPcp2ZQEz5u2XKJHyyygOFdfmIecOhuIjtCy_6i0Meta?.name,
    path: "/dashboard",
    meta: dashboarddIGQPcp2ZQEz5u2XKJHyyygOFdfmIecOhuIjtCy_6i0Meta || {},
    component: () => import("/opt/build/repo/pages/dashboard.vue"),
    children: [
  {
    name: "dashboard-all",
    path: "all",
    component: () => import("/opt/build/repo/pages/dashboard/all.vue")
  },
  {
    name: "dashboard-my-orders",
    path: "my-orders",
    component: () => import("/opt/build/repo/pages/dashboard/my-orders.vue")
  },
  {
    name: "dashboard",
    path: "",
    component: () => import("/opt/build/repo/pages/dashboard/index.vue")
  }
]
  },
  {
    name: "error-test",
    path: "/error-test",
    meta: index_W_cGPvNZ4K2mhxuFSxIRJM87Ye5vsIuPoUUsDX2r70Meta || {},
    component: () => import("/opt/build/repo/pages/error-test/index.vue")
  },
  {
    name: expenseszSYrxJ4pkAgmqya1zPeOh5mSY6YFECca_M_bshqH6SIMeta?.name,
    path: "/expenses",
    meta: expenseszSYrxJ4pkAgmqya1zPeOh5mSY6YFECca_M_bshqH6SIMeta || {},
    component: () => import("/opt/build/repo/pages/expenses.vue"),
    children: [
  {
    name: "expenses-export",
    path: "export",
    component: () => import("/opt/build/repo/pages/expenses/export.vue")
  },
  {
    name: "expenses-new",
    path: "new",
    component: () => import("/opt/build/repo/pages/expenses/new.vue")
  },
  {
    name: _91id_93LL7vsE0nSFJredRTWbC17m91d84hBmm7nNBQIbr0TA8Meta?.name,
    path: ":id()",
    meta: _91id_93LL7vsE0nSFJredRTWbC17m91d84hBmm7nNBQIbr0TA8Meta || {},
    component: () => import("/opt/build/repo/pages/expenses/[id].vue"),
    children: [
  {
    name: "expenses-id-edit",
    path: "edit",
    meta: editGyF4glqLoO1oRVFhuraXz_uMijB0zpopo71gf8bY7ccMeta || {},
    component: () => import("/opt/build/repo/pages/expenses/[id]/edit.vue")
  },
  {
    name: "expenses-id",
    path: "",
    component: () => import("/opt/build/repo/pages/expenses/[id]/index.vue")
  }
]
  },
  {
    name: "expenses",
    path: "",
    component: () => import("/opt/build/repo/pages/expenses/index.vue")
  }
]
  },
  {
    name: forgot_45passwordOIFCeCN4AMh8hgrToHpDpWjsGVd3MBWi_zvta3PbADwMeta?.name,
    path: "/forgot-password",
    meta: { ...(forgot_45passwordOIFCeCN4AMh8hgrToHpDpWjsGVd3MBWi_zvta3PbADwMeta || {}), ...{"middleware":"clear-auth-token"} },
    component: () => import("/opt/build/repo/pages/forgot-password.vue"),
    children: [
  {
    name: "forgot-password-check-email",
    path: "check-email",
    component: () => import("/opt/build/repo/pages/forgot-password/check-email.vue")
  },
  {
    name: "forgot-password-uuid-reset",
    path: ":uuid()/reset",
    component: () => import("/opt/build/repo/pages/forgot-password/[uuid]/reset.vue")
  },
  {
    name: "forgot-password",
    path: "",
    component: () => import("/opt/build/repo/pages/forgot-password/index.vue")
  }
]
  },
  {
    name: "inventory",
    path: "/inventory",
    meta: index52Ckz9CwUDhxG6WXgchvB5XbB8t2IYRStEKJvf7qCPoMeta || {},
    component: () => import("/opt/build/repo/pages/inventory/index.vue"),
    children: [
  {
    name: "inventory-index-id-transactions",
    path: ":id()/transactions",
    component: () => import("/opt/build/repo/pages/inventory/index/[id]/transactions.vue")
  }
]
  },
  {
    name: invoicesksZypTfdfNkd37B_ULP3MP9EobbXZ_Air6nIR1UYV2MMeta?.name,
    path: "/invoices",
    meta: invoicesksZypTfdfNkd37B_ULP3MP9EobbXZ_Air6nIR1UYV2MMeta || {},
    component: () => import("/opt/build/repo/pages/invoices.vue"),
    children: [
  {
    name: "invoices-exports",
    path: "exports",
    component: () => import("/opt/build/repo/pages/invoices/exports.vue")
  },
  {
    name: "invoices-inbox",
    path: "inbox",
    component: () => import("/opt/build/repo/pages/invoices/inbox.vue")
  },
  {
    name: "invoices",
    path: "",
    meta: index0Di72goBjyLuq31l5hhV78_uqtDkILlexkn05WIHbGAMeta || {},
    component: () => import("/opt/build/repo/pages/invoices/index.vue"),
    children: [
  {
    name: "invoices-index-export",
    path: "export",
    component: () => import("/opt/build/repo/pages/invoices/index/export.vue")
  }
]
  }
]
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(logindGU_Y4tTcWsCg9HnKfbgxniTJNnqn8Xqf4N3mbSf_9QMeta || {}), ...{"middleware":"clear-auth-token"} },
    component: () => import("/opt/build/repo/pages/login.vue")
  },
  {
    name: "orders",
    path: "/orders",
    meta: indexOlWd9vFHguHOsQSBcDz6x2XeFrcv2t5_c0Q9Cv_IO0oMeta || {},
    component: () => import("/opt/build/repo/pages/orders/index.vue")
  },
  {
    name: profileYXN2cSixlL75SwObUUSDSPm9Xr5hPfQHYdM_txMKyrEMeta?.name,
    path: "/profile",
    meta: profileYXN2cSixlL75SwObUUSDSPm9Xr5hPfQHYdM_txMKyrEMeta || {},
    component: () => import("/opt/build/repo/pages/profile.vue"),
    children: [
  {
    name: "profile-notifications",
    path: "notifications",
    component: () => import("/opt/build/repo/pages/profile/notifications.vue")
  },
  {
    name: "profile-password",
    path: "password",
    component: () => import("/opt/build/repo/pages/profile/password.vue")
  },
  {
    name: "profile",
    path: "",
    component: () => import("/opt/build/repo/pages/profile/index.vue")
  }
]
  },
  {
    name: "projects",
    path: "/projects",
    meta: indexJxu2jFkvSCWJf6gZ2nAdBaEA0U3aznS_LcN5i2h40XgMeta || {},
    component: () => import("/opt/build/repo/pages/projects/index.vue")
  },
  {
    name: "quickbooks-disconnect",
    path: "/quickbooks-disconnect",
    meta: quickbooks_45disconnectzbJFijVz2RRt1ZvMTNvxn26rouG5EIfNMgkzKPPqkDcMeta || {},
    component: () => import("/opt/build/repo/pages/quickbooks-disconnect.vue")
  },
  {
    name: requisitionsO_Ch7ICMFhaShjRCDBpEqzh8VR8_lakmBQ98H415idQMeta?.name,
    path: "/requisitions",
    meta: requisitionsO_Ch7ICMFhaShjRCDBpEqzh8VR8_lakmBQ98H415idQMeta || {},
    component: () => import("/opt/build/repo/pages/requisitions.vue"),
    children: [
  {
    name: "requisitions-id",
    path: ":id()",
    meta: indexnAKVgOczf25AS5BM5MNTvnnSDIoJLkFNj6AG55Q_I94Meta || {},
    component: () => import("/opt/build/repo/pages/requisitions/[id]/index.vue")
  },
  {
    name: "requisitions",
    path: "",
    component: () => import("/opt/build/repo/pages/requisitions/index.vue")
  }
]
  },
  {
    name: "setup-mode",
    path: "/setup-mode",
    component: () => import("/opt/build/repo/pages/setup-mode.vue")
  },
  {
    name: sign_45upsbyFTKzb27ZDAAG4Ck628G_pZQrSR_Bg9SgR2KtFDGcMeta?.name,
    path: "/sign-up",
    meta: { ...(sign_45upsbyFTKzb27ZDAAG4Ck628G_pZQrSR_Bg9SgR2KtFDGcMeta || {}), ...{"middleware":["signup-enabled","clear-auth-token"]} },
    component: () => import("/opt/build/repo/pages/sign-up.vue"),
    children: [
  {
    name: "sign-up-profile",
    path: "profile",
    component: () => import("/opt/build/repo/pages/sign-up/profile.vue")
  },
  {
    name: "sign-up",
    path: "",
    component: () => import("/opt/build/repo/pages/sign-up/index.vue")
  }
]
  },
  {
    name: "sign-up-mobile",
    path: "/sign-up-mobile",
    meta: { ...(sign_45up_45mobilekSphfmtsSEW21I8eowATaEaxbMvxmQC9sn181l7N25sMeta || {}), ...{"middleware":"signup-enabled"} },
    component: () => import("/opt/build/repo/pages/sign-up-mobile.vue")
  },
  {
    name: "signing",
    path: "/signing",
    meta: signingH9sWnidwxK5Gb6uhbantoVD7Vv2UyWcTFgAho_B1seYMeta || {},
    component: () => import("/opt/build/repo/pages/signing.vue")
  },
  {
    name: suppliers6P25SzaXCJvxgtJhD7nKcsWhzypD51y2KJkd3W_qc2oMeta?.name,
    path: "/suppliers",
    meta: { ...(suppliers6P25SzaXCJvxgtJhD7nKcsWhzypD51y2KJkd3W_qc2oMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/build/repo/pages/suppliers.vue"),
    children: [
  {
    name: new5tuZc0YebIKdTKEs_LUdmG_UqIVEYHx49D0i6yG6bf0Meta?.name,
    path: "new",
    component: () => import("/opt/build/repo/pages/suppliers/new.vue"),
    children: [
  {
    name: "suppliers-new-contacts-new",
    path: "contacts/new",
    component: () => import("/opt/build/repo/pages/suppliers/new/contacts/new.vue")
  },
  {
    name: "suppliers-new-categories",
    path: "categories",
    component: () => import("/opt/build/repo/pages/suppliers/new/categories.vue")
  },
  {
    name: "suppliers-new-contacts",
    path: "contacts",
    component: () => import("/opt/build/repo/pages/suppliers/new/contacts/index.vue")
  },
  {
    name: "suppliers-new",
    path: "",
    component: () => import("/opt/build/repo/pages/suppliers/new/index.vue")
  }
]
  },
  {
    name: "suppliers-id",
    path: ":id()",
    component: () => import("/opt/build/repo/pages/suppliers/[id].vue"),
    children: [
  {
    name: editOxXru9nr3qSUpW7YNsqSdT0Ab_pQtEMFQtlRkacIVcwMeta?.name,
    path: "edit",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit.vue"),
    children: [
  {
    name: "suppliers-id-edit-contacts-new",
    path: "contacts/new",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit/contacts/new.vue")
  },
  {
    name: "suppliers-id-edit-contacts-contactId",
    path: "contacts/:contactId()",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit/contacts/[contactId].vue")
  },
  {
    name: "suppliers-id-edit-categories",
    path: "categories",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit/categories.vue")
  },
  {
    name: "suppliers-id-edit-companies",
    path: "companies",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit/companies.vue")
  },
  {
    name: "suppliers-id-edit-contacts",
    path: "contacts",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit/contacts/index.vue")
  },
  {
    name: "suppliers-id-edit",
    path: "",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit/index.vue")
  }
]
  },
  {
    name: "suppliers-id-merge",
    path: "merge",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/merge.vue")
  }
]
  },
  {
    name: "suppliers",
    path: "",
    component: () => import("/opt/build/repo/pages/suppliers/index.vue")
  }
]
  },
  {
    name: "users",
    path: "/users",
    meta: { ...(index1mG8JMQgCyyObX5use_xFbRcEJCfqtvHcFdfbQ88imoMeta || {}), ...{"middleware":"can-manage-users"} },
    component: () => import("/opt/build/repo/pages/users/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexaAs6F0uOO1PbNxqH8DD_e04gSZQCarVD9TCXJYV94KEMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: suppliersCg_qTwztRQ3MMn8dTzFowm2HIsm6elSqDJApT5fKbKgMeta?.name,
    path: "/companies/:id()/suppliers",
    meta: suppliersCg_qTwztRQ3MMn8dTzFowm2HIsm6elSqDJApT5fKbKgMeta || {},
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers.vue"),
    children: [
  {
    name: importTubWTD76X2mlHQLUMnnlLcb5HaTjYyQ5na1vcYD35kcMeta?.name,
    path: "import",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/import.vue"),
    children: [
  {
    name: "companies-id-suppliers-import-review",
    path: "review",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/import/review.vue")
  },
  {
    name: "companies-id-suppliers-import",
    path: "",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/import/index.vue")
  }
]
  },
  {
    name: "companies-id-suppliers",
    path: "",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index.vue"),
    children: [
  {
    name: addp2DhqDq3aJpc_eEZJikoFMFiw_qP3h_R7TizT2TD7iMMeta?.name,
    path: "add",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/add.vue"),
    children: [
  {
    name: "companies-id-suppliers-index-add-categories",
    path: "categories",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/add/categories.vue")
  },
  {
    name: "companies-id-suppliers-index-add-contacts",
    path: "contacts",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/add/contacts.vue")
  },
  {
    name: "companies-id-suppliers-index-add-in-store",
    path: "in-store",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/add/in-store.vue")
  },
  {
    name: "companies-id-suppliers-index-add-new",
    path: "new",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/add/new.vue")
  },
  {
    name: "companies-id-suppliers-index-add",
    path: "",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/add/index.vue")
  }
]
  },
  {
    name: _91companyVendorId_93_ukRrHpXs3GSefh_UXkwW2lmQ9YZNbhkkcOy_HPgtw0Meta?.name,
    path: ":companyVendorId()",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId].vue"),
    children: [
  {
    name: "companies-id-suppliers-index-companyVendorId-contacts-contact",
    path: "contacts/:contact()",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/contacts/[contact].vue")
  },
  {
    name: "companies-id-suppliers-index-companyVendorId-accounting",
    path: "accounting",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/accounting.vue")
  },
  {
    name: "companies-id-suppliers-index-companyVendorId-contacts",
    path: "contacts",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/contacts/index.vue")
  },
  {
    name: edit3TpG5mfsB40Z7F1_KWIXf_QrQXqTIg99GIBiQTD6lpUMeta?.name,
    path: "edit",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/edit.vue"),
    children: [
  {
    name: "companies-id-suppliers-index-companyVendorId-edit-categories",
    path: "categories",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/edit/categories.vue")
  },
  {
    name: "companies-id-suppliers-index-companyVendorId-edit",
    path: "",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/edit/index.vue")
  }
]
  },
  {
    name: "companies-id-suppliers-index-companyVendorId-map",
    path: "map",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/map.vue")
  },
  {
    name: "companies-id-suppliers-index-companyVendorId",
    path: "",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/index.vue")
  }
]
  }
]
  }
]
  },
  {
    name: newgMUkRG1HRAaZ8RoZepmT7WnRoxwZMGmYvIyZommmfzcMeta?.name,
    path: "/invoices/new",
    meta: newgMUkRG1HRAaZ8RoZepmT7WnRoxwZMGmYvIyZommmfzcMeta || {},
    component: () => import("/opt/build/repo/pages/invoices/new.vue"),
    children: [
  {
    name: "invoices-new",
    path: "",
    component: () => import("/opt/build/repo/pages/invoices/new/index.vue")
  }
]
  },
  {
    name: newqJgyIzdTOzOXlmlIQXf8qv8eMv5XFVsXJF51awegkScMeta?.name,
    path: "/requisitions/new",
    meta: newqJgyIzdTOzOXlmlIQXf8qv8eMv5XFVsXJF51awegkScMeta || {},
    component: () => import("/opt/build/repo/pages/requisitions/new.vue"),
    children: [
  {
    name: "requisitions-new-approval",
    path: "approval",
    component: () => import("/opt/build/repo/pages/requisitions/new/approval.vue")
  },
  {
    name: "requisitions-new-delivery",
    path: "delivery",
    component: () => import("/opt/build/repo/pages/requisitions/new/delivery.vue")
  },
  {
    name: "requisitions-new-review",
    path: "review",
    component: () => import("/opt/build/repo/pages/requisitions/new/review.vue")
  },
  {
    name: "requisitions-new",
    path: "",
    component: () => import("/opt/build/repo/pages/requisitions/new/index.vue")
  }
]
  },
  {
    name: "requisitions-id-edit",
    path: "/requisitions/:id()/edit",
    meta: editMo0HXlBs_0bnutKrnBJVabj54kD9rNFSDDlC4jU5JhQMeta || {},
    component: () => import("/opt/build/repo/pages/requisitions/[id]/edit.vue")
  }
]